import { useFormContext } from 'react-hook-form';

import {
  ControlledCheckbox,
  ControlledSelect
} from 'components/shared/ControlledFields';
import { useGetDisconnectReasonOptions } from '../../../Tables/Settings/DutyHourTypes/components/Sections/UnlinkAutomaticallySection/hooks/useGetDisconnectReasonOptions';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

const RosterSettingsFormContent = () => {
  const options = useGetDisconnectReasonOptions();
  const { control } = useFormContext();

  return (
    <>
      <MultiStepForm.Section
        title={t('rosterSettings.dutyLineCalculationSettings.title')}
      >
        <ControlledCheckbox
          control={control}
          name="dutyLineCalculationSchema.0.value"
          label={t(
            'rosterSettings.dutyLineCalculationSettings.allowExtraHoursFullTime'
          )}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section
        title={t('rosterSettings.decentralizedDutyCodeSettings.title')}
      >
        <ControlledCheckbox
          control={control}
          name="decentralizedDutycodesSchema.0.value"
          label={t('rosterSettings.decentralizedDutyCodeSettings.activeLabel')}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('rosterSettings.defaultValues.title')}>
        <ControlledSelect
          control={control}
          name="defaultValuesSchema.0.value"
          label={t('rosterSettings.defaultValues.defaultLeaveRequestReason')}
          options={options.data || []}
        />
      </MultiStepForm.Section>
    </>
  );
};

export default RosterSettingsFormContent;
